export default __webpack_public_path__ + "static/media/BackgroundImage.eb20f4ea.svg";